import { render } from "./ErrorPage.vue?vue&type=template&id=253a62ce"
const script = {}

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/error/ErrorPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "253a62ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('253a62ce', __exports__)) {
    console.log('reload')
    api.reload('253a62ce', __exports__)
  }
  
  module.hot.accept("./ErrorPage.vue?vue&type=template&id=253a62ce", () => {
    console.log('re-render')
    api.rerender('253a62ce', render)
  })

}


export default __exports__